import BasicDateInput from "components/BasicInputs/BasicDateInput";
import { useFormikContext } from "formik";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import getCurrency from "helpers/currencyHelper";
import { DateToString } from "components/Reports/DateFilter";
import { useEffect } from "react";

export default function DepositReceiptChequeForm(props: any) {
  const form = useFormikContext();
  const values: any = form.values;
  useEffect(() => {
    !values.date && form.setFieldValue("date", DateToString(new Date(Date.now())));
  }, []);
  return (
    <div className="flex flex-col p-2 gap-6">
      <BasicDateInput
        label="تاریخ"
        onChange={(dates) => dates && form.setFieldValue("date", dates[0])}
        required
        withoutClear
        styles={{ container: { width: 200 } }}
        defaultValues={[values?.date]}
      />
      <BasicTextInput
        label="کارمزد تراکنش"
        type="price"
        prefix={<div>{props.cheque?.Currency?.en_title || getCurrency().defCur.en_title}</div>}
        onChange={(val) => form.setFieldValue("wage", val)}
        val={values?.wage}
      />
      <BasicTextInput
        textArea
        label="توضیحات"
        onChange={(val) => form.setFieldValue("description", val)}
        val={values.description}
      />
    </div>
  );
}
